import { isSSR } from "./is-ssr.js";
var MediaManagerMediaType = /* @__PURE__ */ ((MediaManagerMediaType2) => {
  MediaManagerMediaType2["IMAGE"] = "IMAGE";
  MediaManagerMediaType2["ALL_MEDIA"] = "ALL_MEDIA";
  MediaManagerMediaType2["VIDEO"] = "VIDEO";
  MediaManagerMediaType2["AUDIO"] = "MUSIC";
  return MediaManagerMediaType2;
})(MediaManagerMediaType || {});
const createOpenMediaManagerFn = () => {
  if (isSSR()) {
    return void 0;
  }
  const mediaManagerInstance = window.editorSDK || window.ModuleRegistry;
  const isInEditor = mediaManagerInstance && "editor" in mediaManagerInstance;
  const isInBM = mediaManagerInstance && "registeredMethods" in mediaManagerInstance && mediaManagerInstance.registeredMethods && typeof mediaManagerInstance.registeredMethods === "object" && "mediaManager.open" in mediaManagerInstance.registeredMethods;
  if (!mediaManagerInstance || !isInEditor && !isInBM) {
    return void 0;
  }
  return async ({ mediaType, isMultiSelect, appDefId }) => {
    return "editor" in mediaManagerInstance ? mediaManagerInstance.editor.openMediaPanel("", {
      mediaType,
      isMultiSelect
    }) : new Promise((resolve) => {
      mediaManagerInstance.invoke("mediaManager.open", mediaType, appDefId || "", {
        multiSelect: isMultiSelect,
        onSuccess: (data) => resolve(data.items)
      });
    });
  };
};
export {
  MediaManagerMediaType,
  createOpenMediaManagerFn
};
//# sourceMappingURL=create-open-media-manager-fn.js.map
